import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { GpsService } from '@core/services/gps.service';
import { IntervalService } from '../services/interval.service';
@Injectable({
  providedIn: 'root',
})
export class DeactivateGuard implements CanDeactivate<any> {
  constructor(private intervalService: IntervalService, private _gps: GpsService) {
  }
  async canDeactivate(): Promise<boolean> {
    this.intervalService.stopInterval();
    await this._gps.stopWatch();
    return true;
  }
}
